import { render, staticRenderFns } from "./ChargesSettings.vue?vue&type=template&id=53d5d89a&scoped=true"
import script from "./ChargesSettings.vue?vue&type=script&lang=js"
export * from "./ChargesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d5d89a",
  null
  
)

export default component.exports